export const WIDGET_DATA_TABLE_REQUEST = "WIDGET_DATA_TABLE_REQUEST";
export const WIDGET_DATA_TABLE_UPDATE = "WIDGET_DATA_TABLE_UPDATE";
export const WIDGET_DATA_TABLE_UPDATED = "WIDGET_DATA_TABLE_UPDATED";
export const WIDGET_DATA_TABLE_DELETE = "WIDGET_DATA_TABLE_DELETE";
export const WIDGET_DATA_TABLE_CREATE = "WIDGET_DATA_TABLE_CREATE";
export const WIDGET_DATA_TABLE_SUCCESS = "WIDGET_DATA_TABLE_SUCCESS";
export const WIDGET_DATA_TABLE_ERROR = "WIDGET_DATA_TABLE_ERROR";
export const WIDGET_DATA_TABLE_LOADED = "WIDGET_DATA_TABLE_LOADED";
